var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10a9.319 9.319 0 00-4.25 1.01A9.495 9.495 0 0011 19.5c-.003 1.32.312 2.61.844 3.81l-1.79 5.38a1 1 0 001.27 1.26l5.38-1.79c1.2.533 2.49.849 3.81.846a9.518 9.518 0 004.99-1.42 9.483 9.483 0 003.5-3.83v-.002a9.446 9.446 0 001.01-4.25v-.496a1 1 0 00-.002-.057 9.478 9.478 0 00-2.76-6.18 9.434 9.434 0 00-6.18-2.76 1 1 0 00-.055 0h-.498zm-.002 2a1 1 0 00.002 0h.453c1.84.103 3.57.877 4.87 2.18s2.07 3.03 2.18 4.87v.453a1 1 0 000 .002 7.41 7.41 0 01-.793 3.35 1 1 0 00-.002.004 7.556 7.556 0 01-2.76 3.03 7.487 7.487 0 01-3.94 1.12 1 1 0 00-.002 0 7.41 7.41 0 01-3.35-.793 1 1 0 00-.768-.057l-3.8 1.27 1.27-3.8a1 1 0 00-.057-.768 7.38 7.38 0 01-.793-3.35 1 1 0 000-.002 7.484 7.484 0 014.15-6.7 1 1 0 00.004-.002 7.409 7.409 0 013.35-.79z"
  })));
}

export default SvgDescription;